export enum Seccion{
  PEDIDO="PEDIDO",
  PEDIDO_NEW="PEDIDO_CONSUMIDOR_FINAL",
  LOGUEO="LOGUEO"
}
